const ACOES = {
    INSERIR: 2,
    ALTERAR: 3,
    EXCLUIR: 4,
    CONSULTAR: 5,
    VISUALIZAR: 6,
    VALIDAR: 7,
    REENVIAR: 8,
    IMPORTAR: 9,
    ENVIAR: 10,
    EMITIR_RELATORIO: 11,
    OBSERVACAO_AGENDA: 12,
    CANCELAR_AGENDA: 17,
    FINALIZAR_AGENDA: 18,
    CONFIRMAR_AGENDA: 19,
    ALTERAR_STATUS_AGENDA: 20,
    TROCAR_SOCIO: 22,
    EXCLUIR_SOCIOS: 23,
    TROCAR_STATUS: 23,
    CANCELAMENTO_LOTE: 12,
    DEVOLUCAO_LOTE: 13,
    ENVIO_LOTE: 14,
    DOWNLOAD: 15
}

const MODULO = {
    '/controleacesso/usuario': 1,
    '/controleacesso/grupo': 2,
    '/controleacesso/modulo': 3,
    '/controleacesso/auditoria': 8,
    '/controleacesso/auditoria/0': 8,
    '/controleacesso/usuarioapp': 44,
    '/controleacesso/auditoriaapp/0': 48,
    '': 4,
    '/estoque/produtopaginacao/0': 6,
    '/estoque/produtoentradasaidapaginacao/0': 11,
    '/estoque/produtoentradasaida': 11,
    '/estoque/produto': 6,
    '/estoque/produtoentrada': 9,
    '/estoque/produtosaida': 10,
    '/relatorio/relatoriolistagemproduto': 7,
    '/relatorio/relatorioprodutoporfornecedor': 7,
    '/relatorio/relatoriolistagementradaproduto': 12,
    '/relatorio/relatorioprodutoporresponsavel': 7,
    '/devolucao/lote': 13,
    '/devolucao/lotepaginacao/0': 13,
    '/devolucao/cancelamento': 13,
    '/devolucao/entrega': 13
}

const STATUS_DEVOLUCAO_COR = {
    1: '#db8318',
    2: '#00bfff',
    3: '#00ad62'
}

export { ACOES, MODULO, STATUS_DEVOLUCAO_COR }